export class AbortError extends Error {
    type;
    code;
    constructor(message, code, name) {
        super(message ?? 'The operation was aborted');
        this.type = 'aborted';
        this.code = code ?? 'ABORT_ERR';
        this.name = name ?? 'AbortError';
    }
}
//# sourceMappingURL=abort-error.js.map